import { render, staticRenderFns } from "./import-provider-modal.vue?vue&type=template&id=7987cab8"
import script from "./import-provider-modal.vue?vue&type=script&lang=js"
export * from "./import-provider-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports